import { faIcon } from "@utils/faIcon"
import formatDuration from "@utils/formatDuration"

import { Badge } from "@atoms"

import { DurationBadgeProps } from "./DurationBadge.types"

const icon = faIcon({ name: "hourglass", style: "regular" })

export default function DurationBadge(props: DurationBadgeProps) {
    const { duration, size = "md", label = "Estimated duration" } = props

    if (duration == null) {
        return null
    }

    // e.g. "Estimated duration\n1 hour 30 minutes".
    const tooltip = `${label}\n${formatDuration(duration, "long")}`

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={tooltip}>
            {formatDuration(duration)}
        </Badge>
    )
}
